import React, { Component } from 'react'
import Routes from './Routes';
import NavBar from '../components/NavBar';
import SideBar from '../components/SideBar';
import Master from './Master';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';

//structure component for the layout of the ui

const useStyles = makeStyles(theme => ({
    toolbar: theme.mixins.toolbar,
  }));

export default function Template() {

    const classes = useStyles();

    return (
        <Master>
            <Router>
                <NavBar />

                <div className={classes.toolbar} />
                <Routes />

            </Router>
        </Master>
    );

}
